/* app/js/src/components/media-transcoder/jobs/history/history.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.history-jobs-container .filters-bar .name-filter-input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.history-jobs-container .filters-bar .name-filter-input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.history-jobs-container .filters-bar .name-filter-input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.history-jobs-container .filters-bar .name-filter-input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.history-jobs-container .filters-bar .name-filter-input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.history-jobs-container .filters-bar .name-filter-input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.history-jobs-container .filters-bar .ng-invalid.ng-dirty.name-filter-input,
.history-jobs-container .filters-bar .ng-invalid.ng-touched.name-filter-input {
  border-color: #ef5350;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  display: block;
  position: relative;
  min-height: 180px;
}
.history-jobs-container {
  margin-top: 1vw;
}
.history-jobs-container .filters-bar {
  align-items: center;
  gap: 1.5vw;
  margin-bottom: 1vw;
  flex-wrap: wrap;
}
.history-jobs-container .filters-bar .filter-group {
  display: flex;
  align-items: center;
  gap: 0.75vw;
  flex: 0 0 auto;
}
.history-jobs-container .filters-bar .filter-group.bulk-action {
  margin-left: auto;
}
.history-jobs-container .filters-bar .filter-label {
  color: #232f3a;
  font-weight: 600;
  flex: 0 0 auto;
  line-height: 30px;
}
.history-jobs-container .filters-bar .name-filter-input {
  width: 14rem;
  min-width: 14rem;
  height: 30px;
  box-sizing: border-box;
  margin: 0;
  line-height: 30px;
  padding: 0 15px;
}
.history-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown {
  display: inline-block;
  width: 14rem !important;
  min-width: 14rem;
  height: 30px !important;
  vertical-align: middle;
}
.history-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown .main-container {
  height: 100%;
}
.history-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown .selected-container {
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
}
:host ::ng-deep .history-bulk-redo-modal .nsm-dialog-btn-close {
  display: none !important;
}
.history-jobs-container .recording-history-grid {
  height: calc(80vh - 30px);
}
.history-jobs-container .recording-history-grid ::ng-deep .recording-status > span {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.history-jobs-container .recording-history-grid ::ng-deep .recording-status > span img {
  width: 17px;
  height: 17px;
}
.jobs-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  color: #232f3a;
}
.jobs-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.jobs-table tbody tr:hover {
  background-color: #e7dfdf;
}
.jobs-table th {
  border-bottom: 1px solid #232f3a;
}
.jobs-table th,
.jobs-table td {
  height: 2vw;
  padding: 0 0.75vw;
  text-align: left;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}
.jobs-table th:nth-child(1),
.jobs-table td:nth-child(1) {
  width: 26%;
  word-break: break-word;
  white-space: normal;
}
.jobs-table th:nth-child(5),
.jobs-table td:nth-child(5) {
  width: 8%;
  min-width: 5rem;
  white-space: nowrap;
}
.jobs-table th:nth-child(6),
.jobs-table td:nth-child(6) {
  width: 16%;
  min-width: 8rem;
  white-space: normal;
  word-break: break-word;
}
.jobs-table th:nth-child(7),
.jobs-table td:nth-child(7),
.jobs-table th:nth-child(8),
.jobs-table td:nth-child(8) {
  width: 7%;
  min-width: 4.5rem;
  white-space: nowrap;
}
.jobs-table .status-cell {
  color: #232f3a;
}
.jobs-table .redo-cell a {
  color: #40c4ff;
  text-decoration: none;
  white-space: nowrap;
}
.jobs-table .redo-cell a:hover {
  text-decoration: underline;
}
.jobs-table td > a,
.jobs-table td > span {
  color: #40c4ff;
  cursor: pointer;
  text-decoration: none;
}
.jobs-table td > a:hover,
.jobs-table td > span:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=history.component.css.map */
